/* ============================================================
   Boldpurity® — Product Card JS
   assets/bp-product-card.js

   Link in theme.liquid (before </body>):
   {{ 'bp-product-card.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';

  function bpAddToCart(variantId, button) {
    if (!variantId) return;
    var original = button.textContent;
    button.classList.add('bp-card__cta--loading');
    button.textContent = 'Adding…';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        button.classList.remove('bp-card__cta--loading');
        button.disabled = false;

        if (data.status && data.status !== 200) {
          button.textContent = original;
          console.warn('[Boldpurity] Add to cart error:', data.description);
          return;
        }

        button.textContent = 'Added ✓';
        button.classList.add('bp-card__cta--success');

        /* Notify theme cart components (drawer, bubble, etc.) */
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        /* Reset button after 2 seconds */
        setTimeout(function () {
          button.textContent = original;
          button.classList.remove('bp-card__cta--success');
        }, 2000);
      })
      .catch(function (err) {
        button.classList.remove('bp-card__cta--loading');
        button.textContent = original;
        button.disabled = false;
        console.error('[Boldpurity] Cart fetch error:', err);
      });
  }

  /* Delegate clicks on both the body CTA and the hover quick-add */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bp-card__cta:not(.bp-card__cta--disabled), .bp-card__quick-add');
    if (!btn) return;
    var variantId = btn.dataset.variantId;
    if (variantId) {
      e.preventDefault();
      bpAddToCart(variantId, btn);
    }
  });
})();
